// extracted by mini-css-extract-plugin
export var changeIcon = "_5d-4";
export var clickable = "_5d-8";
export var container = "_5d-0";
export var divider = "_5d-7";
export var externalLinkIcon = "_5d-1";
export var green = "_5d-5";
export var helpCircleIcon = "_5d-3";
export var iconButton = "_5d-2";
export var red = "_5d-6";